// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ModalFooter__modalFooter___18V-5"};